export enum SettingsOption {
    GENERAL = 'General',
    DOCUMENT_ACCESS_TYPES = 'Tipuri Acces (Documente)',
    PRIORITIES = 'Priorități',
    STATUSES = 'Statusuri',
    DOCUMENT_TYPES = 'Tipuri Documente (registratură)',
    SERIES_DOCUMENTS = 'Serii Documente',
    SOURCES_DOCUMENTS = 'Surse Documente',
    PERSONS_ENTITY_TYPES = 'Tipuri Persoane/Beneficiari',
    DOCUMENT_FINALIZATION_TYPES = 'Tipuri finalizare documente',
    TEMPLATE_DOCUMENTE = 'Template Documente',
    CATEGORII_TEMPLATE = 'Categorii Template',
    HEADER_FOOTER = 'Antet/Subsol Documente',
    //   COUNTIES = 'Județe',
    NON_WORKING_DAYS = 'Zile libere (nelucrătoare)',
    DOCUMENT_TYPES_FILES = 'Tipuri Documente (fișiere)',
    REDIRECTION_ADDRESSES = 'Adrese Redirecționare',
    DIRECTIE_SERII = 'Instituție/Servicii - Serii/Seq',
    STATUSURI_POSTA = 'Statusuri Poștă',
    OFICII_POSTALE = 'Oficii Poștale',
    EMAILS_BLACKLIST = 'Blacklist',
    OPERATORI = 'Operatori',
}

export enum AdminSettings {
    CONFIGURARI = 'Configurări',
    STORAGE_LOCATIONS = 'Storage Locations',
    CRON = 'Cron-uri',
    SIGNER = 'Semnare Digitală',
    SIGNING_LOGS = 'Signing Logs',
    AUDIT_LOGS = 'Audit Logs',
    AUDIT_ARCHIVES = 'Arhive Audit',
}
